var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mars3dContainer",staticClass:"mars3d-container",attrs:{"id":("mars3d-container-" + _vm.mapKey)}})}
var staticRenderFns = []

export { render, staticRenderFns }